import { inject } from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { take } from 'rxjs/operators';

export const isAuthenticated = (state: RouterStateSnapshot) => {
  const oidcSecurityService = inject(OidcSecurityService);
  const router = inject(Router);

  return oidcSecurityService.isAuthenticated$.pipe(take(1)).subscribe(({ isAuthenticated }) => {
    // allow navigation if authenticated
    if (isAuthenticated) {
      return true;
    }

    // redirect if not authenticated
    const returnUrl = state.url;
    router.navigate(['portal/login'], { queryParams: { returnUrl } });
    return false;
  });
};
